import React, { useState, useEffect, useCallback } from 'react';
import { getUpcomingDeadlines } from '../services/api';
import { formatDate } from '../utils/formatDate';
import './UpcomingDeadlinesWidget.css';

const DAYS_OPTIONS = [3, 7, 14, 30];

function UpcomingDeadlinesWidget() {
  const [deadlines, setDeadlines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [days, setDays] = useState(7);

  const fetchDeadlines = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getUpcomingDeadlines(days);
      if (res.success) setDeadlines(res.deadlines || []);
    } catch {
      setDeadlines([]);
    } finally {
      setLoading(false);
    }
  }, [days]);

  useEffect(() => {
    fetchDeadlines();
  }, [fetchDeadlines]);

  return (
    <div className="upcoming-deadlines-widget">
      <div className="udw-header">
        <h3>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18" style={{ verticalAlign: 'middle', marginRight: 6 }}>
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          Upcoming Deadlines
        </h3>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} className="udw-days-select">
          {DAYS_OPTIONS.map((d) => (
            <option key={d} value={d}>Next {d} days</option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="udw-loading">Loading…</div>
      ) : deadlines.length === 0 ? (
        <div className="udw-empty">No upcoming deadlines in the next {days} days.</div>
      ) : (
        <ul className="udw-list">
          {deadlines.map((d) => (
            <li key={d.id} className={`udw-item udw-${d.urgency}`}>
              <div className="udw-item-top">
                <span className="udw-ref">{d.tender_ref}</span>
                <span className={`udw-days-left udw-urgency-${d.urgency}`}>
                  {d.days_left === 0 ? 'Today' : d.days_left === 1 ? '1 day left' : `${d.days_left} days left`}
                </span>
              </div>
              <div className="udw-item-title">{d.title || d.buyer_name || '—'}</div>
              <div className="udw-item-deadline">{formatDate(d.submission_deadline)}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default UpcomingDeadlinesWidget;
